import { FC } from "react"
import SettingsIcon from "@/shared/assets/icons/settings-sliders.svg?react"
import { Button } from "@/shared/ui/buttons/Button"
import classes from "./styles.module.scss"

interface SettingsButtonProps {
	onClick: () => void
	isNormal?: boolean
}

export const SettingsButton: FC<SettingsButtonProps> = ({ onClick, isNormal = true }) => {
	return (
		<Button variant="icon" onClick={onClick}>
			<SettingsIcon width={19} height={19} className={isNormal ? classes.normal : classes.cross} />
		</Button>
	)
}
